'use strict';
angular.module('iwouserAndDeptTransferModule', []).controller('iwouserAndDeptTransferCtrl', [
    '$scope',
    'globleParamsSet',
    '$modalInstance',
    'trsHttpService',
    '$timeout',
    'modalDialog',
    'treeService',
    'trsGroupTreeLocationService',
    'params',
    'selectedUser',
    'selectedType',
    'iwoNoticeService',
    'tabArr',
    'title',
    '$filter',
    function(
        $scope,
        globleParamsSet,
        $modalInstance,
        trsHttpService,
        $timeout,
        modalDialog,
        treeService,
        trsGroupTreeLocationService,
        params,
        selectedUser,
        selectedType,
        iwoNoticeService,
        tabArr,
        title,
        $filter
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                selectedType: selectedType, // 0:用户 1:部门 2:分组
                SearchValue: '',
            };
            $scope.searchWords = '';
            $scope.static = {
                ifExpand: true,
                userGroup: '用户所属组织',
                treeOptions: {
                    nodeChildren: 'CHILDREN',
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: 'copyDraftTree-ul',
                        li: 'copyDraftTree-li',
                        liSelected: 'a7',
                        iExpanded: 'a3',
                        iCollapsed: 'a4',
                        iLeaf: 'a5',
                        label: 'copyDraftTree-label',
                        labelSelected: 'rolegrouplabselected',
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN === 'false';
                    },
                    isSelectable: function(node) {
                        return node.PARENTID !== '0';
                    },
                },
            };
            $scope.data = {
                selectedUsersArray: [],
                selectedDeptArray: [],
                selectedGroup: [], // 已选择的分组
                tplUserDatas: [],
                groupPaths: selectedType == 0 ? [] : selectedType == 2 ? [] : selectedUser,
                tabArr: tabArr || [0, 1, 2],
                title: title,
                tabHeadType: [
                    {
                        name: '按人员选择',
                        v: 0,
                    },
                    {
                        name: '按部门选择',
                        v: 1,
                    },
                    {
                        name: '按分组选择',
                        v: 2,
                    },
                ],
                groupList: [], // 分组的列表
            };
            $scope.selectedArray = selectedUser;
            if (selectedType === 2) {
                $scope.data.selectedGroup = selectedUser;
            }
            $scope.data1 = {};
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            initUsers();
            $scope.$watch('searchWord', function(newValue, oldValue, scope) {
                if (angular.isObject(newValue)) {
                    var flag = true;
                    angular.forEach($scope.itemsSd, function(data, index, array) {
                        if (data.ID == newValue.ID) {
                            flag = false;
                        }
                    });
                    if (flag) {
                        $scope.isRequest = true;
                        newValue.OPERTYPE = newValue.TYPE;
                        newValue.DESC = newValue.USERNAME;
                        $scope.itemsSd.push(newValue);
                    }
                    $scope.searchWord = newValue.USERNAME;
                }
            });
            getGroupList();
            // $scope.fullTextSearch();
        }

        /**
         * [switchSelectType description] 选择模式切换
         * @return {[type]}      [description]
         */
        $scope.switchSelectType = function() {
            $scope.status.selectedType = $scope.status.selectedType == 0 ? 1 : 0;
            if ($scope.status.selectedType == 0) {
                $scope.selectedArray = $scope.itemsSd;
                // $scope.userDatas = [];
                $scope.selectedNodePA = $scope.selectedNode;
            } else {
                $scope.selectedArray = $scope.data.groupPaths;
                $scope.selectedNode = $scope.selectedNodePA;
                $scope.selectedNodePA = {};
            }
            // initData();
        };
        // 用户选择
        initUsers();
        var noRightFilter;
        $scope.showSelected = function(node) {
            getGroupData(node);
        };
        $scope.showToggle = function(node) {
            childrenTree(node, function() {});
        };
        $scope.toRight = function() {
            angular.forEach($scope.userDatas, function(data, index, array) {
                data.DESC = data.USERNAME;
                if (data.selected === 'selected') {
                    delete data.selected;
                    $scope.itemsSd = globleParamsSet.arrayContrast([angular.copy(data)], angular.copy($scope.itemsSd), 'ID', 'USERNAME');
                    $scope.userDatas[index].selected = '';
                    $scope.selectedUser.push(data.ID);
                }
            });
            $scope.selectedArray = $scope.itemsSd;
        };
        $scope.chooseUserName = function(type, user) {
            if (angular.isDefined(user.selected) && user.selected === 'selected') {
                user.selected = '';
            } else {
                user.selected = 'selected';
                if (type == 'toChoose') {
                    $scope.toChooseUser = user;
                } else if (type == 'cancelChoose') {
                    $scope.cancelChooseUser = user;
                }
            }
        };
        // 输入过滤器
        $scope.myFilter = function(expected, actual) {
            var flag = true;
            // if ($scope.searchWordLeft !== '' && angular.isDefined($scope.searchWordLeft)) {
            //     flag = expected.USERNAME.indexOf($scope.searchWordLeft) >= 0 ? true : false;
            // }
            if ($scope.searchWords !== '' && angular.isDefined($scope.searchWords)) {
                flag = expected.USERNAME.indexOf($scope.searchWords) >= 0;
            }
            return flag;
        };
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode === 13) || angular.isUndefined(ev)) {
                if ($scope.status.selectedType === 2) {
                    // getGroupList();
                } else if ($scope.status.selectedType === 1) {
                    // $scope.treedataPA = $scope.treedataPA.filter((item) => {
                    //     return $scope.deptCovert(item);
                    // });
                    // if (!$scope.searchWords) {
                    //     $scope.treedataPA = angular.copy($scope.treedataOriginPA);
                    //     console.log($scope.treedataOriginPA);
                    // }
                }
            }
        };

        /**
         * [deptCovert description]部门的过滤
         *
         * @param   {[type]}  item  [arr description]
         *
         * @return  {[type]}       [return description]
         */
        $scope.deptCovert = function(item) {
            // function(item){
            if (item.GNAME.indexOf($scope.searchWords) > -1) {
                return true;
            }
            if (item.hasOwnProperty('CHILDREN')) {
                item.CHILDREN = item.CHILDREN.filter(function(child) {
                    if (!child.hasOwnProperty('CHILDREN')) {
                        return child.GNAME.indexOf($scope.searchWords) > -1;
                    } else if (child.hasOwnProperty('CHILDREN')) {
                        return $scope.deptCovert(child);
                    }
                });
                if (item.CHILDREN.length > 0) {
                    return true;
                }
            } else {
                return item.GNAME.indexOf($scope.searchWords) > -1;
            }
        };

        // 输入过滤器
        // 双击选择开始
        $scope.directlyToRight = function(user) {
            // $scope.toRight();
            delete user.selected;
            user.DESC = user.USERNAME;
            $scope.selectedUser.push(user.ID);
            $scope.itemsSd = globleParamsSet.arrayContrast([angular.copy(user)], $scope.itemsSd, 'ID', 'UNAME');
            // $scope.itemsSd = $filter('unique')($scope.itemsSd, 'ID');
            // console.log($scope.itemsSd);
        };
        // 双击选择结束
        // 双击取消选择开始
        $scope.directlyToLeft = function(user) {
            globleParamsSet.contrastAfExclArray([user], $scope.itemsSd, 'ID', 'USERNAME', function(data) {
                $scope.itemsSd = data;
            });
        };
        $scope.selectedAll = function() {
            const filterData = $scope.userDatas.filter((item) => item.USERNAME.indexOf($scope.searchWords) > -1);
            angular.forEach(filterData, function(data, index, array) {
                delete data.selected;
                data.DESC = data.USERNAME;
                $scope.itemsSd = globleParamsSet.arrayContrast([angular.copy(data)], angular.copy($scope.itemsSd), 'ID', 'OPERTYPE');
                $scope.userDatas[index].selected = '';
                if ($scope.selectedUser.indexOf(data.ID) < 0) {
                    $scope.selectedUser.push(data.ID);
                }
            });
            $scope.selectedArray = $scope.itemsSd;
        };
        // 双击取消选择结束
        $scope.toLeft = function() {
            var toRemoveList = [];
            angular.forEach($scope.itemsSd, function(data, index, array) {
                if (angular.isDefined(data.selected) && data.selected === 'selected') {
                    toRemoveList.push(data);
                    $scope.selectedUser.splice($scope.selectedUser.indexOf(data.ID), 1);
                }
            });
            globleParamsSet.contrastAfExclArray(toRemoveList, $scope.itemsSd, 'ID', 'USERNAME', function(data) {
                $scope.itemsSd = data;
            });
            $scope.selectedArray = $scope.itemsSd;
        };

        /**
         * [reset description] 重置
         * @return {[type]} [description]
         */
        $scope.reset = function() {
            if ($scope.status.selectedType == 0) {
                $scope.itemsSd = [];
                $scope.selectedUser = [];
            } else if ($scope.status.selectedType == 1) {
                $scope.data.groupPaths = [];
            } else {
                $scope.data.selectedGroup = [];
            }
            $scope.selectedArray = [];
        };
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        $scope.submit = function() {
            $modalInstance.close({ selectedArray: $scope.selectedArray, selectedType: $scope.status.selectedType });
        };

        // 切换tab标签
        $scope.selectTypeSwitch = function(param) {
            $scope.status.selectedType = param;
            // 切换清空
            $scope.searchWords = '';
            switch (param) {
                case 0:
                    $scope.selectedArray = $scope.itemsSd;
                    $scope.treedataPA = angular.copy($scope.treedataOriginPA);
                    break;
                case 1:
                    $scope.selectedArray = $scope.data.groupPaths;
                    $scope.treedataPA = angular.copy($scope.treedataOriginPA);
                    break;
                case 2:
                    $scope.selectedArray = $scope.data.selectedGroup;
                    break;
            }
        };

        /**
         * [initUsers description]初始化
         *
         * @return  {[type]}  [return description]
         */
        function initUsers() {
            // 组织树配置文件
            $scope.treePAOptions = {
                nodeChildren: 'CHILDREN',
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: 'a1',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'a3',
                    iCollapsed: 'a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'a8',
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN == 'false';
                },
                isSelectable: function(node) {
                    return noRightFilter ? true : node.HASRIGHT === 'true';
                },
            };
            $scope.expandedPA = angular.copy($scope.expandedTest);
            noRightFilter = angular.isDefined(params) && angular.isDefined(params) && params.rightFilter === false;
            var treeParams = {
                serviceid: 'mlf_group',
                methodname: noRightFilter ? 'queryGroupTreeWithMyPath' : 'queryGroupTreeWithSecondRight' /* "queryGroupTreeWithMyPath"*/,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), treeParams, 'get').then(
                function(data) {
                    $scope.treedataPA = [data];
                    // 获得一个原始数组
                    $scope.treedataOriginPA = [data];
                    console.log($scope.treedataPA);
                    ExpandedNodes();
                },
                function(data) {}
            );
            // 初始化最近记录限制
            $scope.limitRecordNum = 10;
            // 初始化选择列表
            $scope.itemsSd = selectedType == 0 ? selectedUser || [] : [];
            $scope.selectedUser = [];
        }

        /**
         * [ExpandedNodes description]默认展开项开始
         *
         * @return  {[type]}  [return description]
         */
        function ExpandedNodes() {
            $scope.expandedPA = [];
            $scope.expandedPA.push($scope.treedataPA[0]);
            if (!noRightFilter) {return;}
            var flag = true;
            angular.forEach($scope.treedataPA[0].CHILDREN, function(data, index, array) {
                if (data.ISPATH === 'true') {
                    flag = false;
                    if (angular.isDefined(data.CHILDREN) && data.CHILDREN.length !== 0) {
                        $scope.expandedPA.push(data);
                        selfPath(data);
                    } else {
                        $scope.selectedNode = data;
                        getGroupData($scope.selectedNode);
                    }
                }
            });
            if (flag) {
                $scope.selectedNodePA = $scope.treedataPA[0];
                getGroupData($scope.selectedNodePA);
            }
            // /*if ($scope.treedataPA[0].CHILDREN === 0) {
            //     $scope.selectedNodePA = $scope.treedataPA[0];
            //     getGroupData($scope.selectedNodePA);
            // } else {
            //     angular.forEach($scope.treedataPA[0].CHILDREN, function(data, index, array) {
            //         if (data.ISPATH === "true") {
            //             $scope.expandedPA.push(data);
            //             if (data.CHILDREN.length !== 0) {
            //                 selfPath(data);
            //             } else {
            //                 $scope.selectedNodePA = data;
            //                 getGroupData($scope.selectedNodePA);
            //             }

            //         }
            //     });
            // }*/
        }

        /**
         * [getGroupList description]获得分组信息
         *
         * @return  {[type]}  [return description]
         */
        function getGroupList() {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'queryOrganizationsByKeyWords',
                pageSize: 100,
                keyWords: $scope.searchWords,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.groupList = data.DATA;
                // console.log(data);
            });
        }

        /**
         * [getGroupData description]
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        function getGroupData(node) {
            $timeout(function() {
                // 此判断如果两次点击同一个树，不重复加载角色列表。
                $scope.groupObj = node;
                $scope.oldSelectNode = node;
                $scope.Datas = [];
                $scope.userData = null;
                var params = {
                    serviceid: 'mlf_group',
                    methodname: 'getUsersByGroup',
                    GroupId: $scope.groupObj.GROUPID,
                };
                // trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function(data) {
                        $scope.userDatas = data;

                        /* if (angular.isDefined(node.CHILDREN)&&node.CHILDREN.length === 0) {
                            childrenTree(node, function() {
                                $scope.userDatas = $scope.userDatas.concat(node.CHILDREN);
                            });
                        } else {
                            $scope.userDatas = $scope.userDatas.concat(node.CHILDREN);
                        }*/
                    },
                    function(data) {
                        modalDialog.alertType('错误提示', '获取子组失败', 'warning', false, function() {});
                    }
                );
            }, 100);
        }

        /**
         * [selfPath description]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function selfPath(data) {
            for (var i = 0; i < data.CHILDREN.length; i++) {
                if (data.CHILDREN[i].ISPATH === 'true') {
                    if (data.CHILDREN[i].HASCHILDREN === 'false' || data.CHILDREN[i].CHILDREN.length === 0) {
                        $scope.selectedNodePA = data.CHILDREN[i];
                        getGroupData($scope.selectedNodePA);
                        break;
                    } else {
                        $scope.expandedPA.push(data.CHILDREN[i]);
                        selfPath(data.CHILDREN[i]);
                        break;
                    }
                }
            }
        }

        /**
         * [childrenTree description]
         *
         * @param   {[type]}  node      [node description]
         * @param   {[type]}  callback  [callback description]
         *
         * @return  {[type]}            [return description]
         */
        function childrenTree(node, callback) {
            if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
                var paramsT = {
                    serviceid: 'mlf_group',
                    methodname: noRightFilter ? 'queryChildGroupsWithOutRight' : 'queryChildGroupsWithSecondRight',
                    GroupId: node.GROUPID,
                };
                trsHttpService.httpServer('/wcm/mlfcenter.do', paramsT, 'get').then(
                    function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    },
                    function(dataC) {
                        modalDialog.alertType('错误提示', '获取子组失败', 'warning', false, function() {});
                    }
                );
            }
        }
        // var promise;
        // $scope.getSuggestions = function(viewValue) {
        //     if (promise) {
        //         $timeout.cancel(promise);
        //         promise = null;
        //     }
        //     promise = $timeout(function() {
        //         if (viewValue !== '') {
        //             var searchUsers = {
        //                 serviceid: 'mlf_extuser',
        //                 Name: viewValue,
        //                 IsHasRight: true,
        //                 IsSearchHide: true,
        //             };
        //             searchUsers.methodname = !noRightFilter ? 'queryUsersByName' : 'searchUserOrDept'; //过滤是否带权限
        //             if ($scope.isRequest) {
        //                 $scope.isRequest = false;
        //                 return [];
        //             } else {
        //                 return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, 'post').then(function(data) {
        //                     angular.forEach(data, function(data_, index, array) {
        //                         data[index].viewValue = viewValue;
        //                     });
        //                     return data;
        //                 });
        //             }
        //         }
        //     });
        //     return promise;
        // };

        /**
         * [selectedOption description] 选择节点
         * @param  {[type]} node [description] 节点取消
         * @return {[type]}      [description]
         */
        $scope.selectedOption = function(node) {
            if ($scope.status.selectedType == 0) {
                $scope.showSelected(node);
                $scope.selectedArray = $scope.itemsSd;
            } else if ($scope.status.selectedType == 1) {
                getGroupData1(node);
                $scope.selectedArray = $scope.data.groupPaths;
            }
        };

        /**
         * [singleSelectedOption description] 单击选择节点
         * @param  {[type]} node [description] 节点
         * @return {[type]}      [description]
         */
        $scope.singleSelectedOption = function(node) {
            if ($scope.status.selectedType == 0) {
                $scope.chooseUserName('toChoose', node);
            }
        };

        /**
         * [dbSelectedOption description] 双击选择节点
         * @param  {[type]} node [description] 节点
         * @return {[type]}      [description]
         */
        $scope.dbSelectedOption = function(node) {
            if (node.HASRIGHT === 'false') {
                return;
            }
            if ($scope.status.selectedType == 0) {
                $scope.directlyToRight(node);
                $scope.selectedArray = $scope.itemsSd;
            } else if ($scope.status.selectedType == 1) {
                $scope.chooseGroup1(node);
                // $scope.cancelGroup1(node);
                $scope.selectedArray = $scope.data.groupPaths;
            } else {
                $scope.chooseOrCancelFenzu(node);
                $scope.selectedArray = $scope.data.selectedGroup;
            }
        };

        /**
         * [unselectedOption description] 取消选择节点
         * @param  {[type]} node [description] 节点
         * @return {[type]}      [description]
         */
        $scope.unselectedOption = function(node) {
            if ($scope.status.selectedType == 0) {
                $scope.directlyToLeft(node);
                $scope.selectedArray = $scope.itemsSd;
            } else if ($scope.status.selectedType == 1) {
                cancelGroup1(node);
                $scope.selectedArray = $scope.data.groupPaths;
            } else {
                $scope.data.selectedGroup.splice($scope.data.selectedGroup.indexOf(node), 1);
                $scope.selectedArray = $scope.data.selectedGroup;
            }
        };

        /** *==========================组织选择======================***/
        /**
         * [showToggle description]树展开方法
         * @param  {[obj]} node [description]父节点
         * @return {[type]}        [description]
         */

        $scope.showToggle1 = function(node) {

            /* if (node.HASCHILDREN === "false" || (angular.isDefined(node.CHILDREN) && node.CHILDREN.length !== 0))
                return;
            treeService.queryChildGroupsForGroupUserMgr("", node.GROUPID).then(function(data) {
                node.CHILDREN = data.CHILDREN;
            });*/
            childrenTree1(node, function() {});
        };

        /**
         * [childrenTree description获取子组织]
         * @param  {[type]}   node     [description]
         * @param  {Function} callback [description]
         * @return {[type]}            [description]
         */
        function childrenTree1(node, callback) {
            if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
                var paramsT = {
                    serviceid: 'mlf_group',
                    methodname: 'queryChildGroupsWithSecondRight',
                    GroupId: node.GROUPID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, 'get').then(
                    function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    },
                    function(dataC) {
                        modalDialog.alertType('错误提示', '获取子组失败', 'error', 'confirm', function() {});
                    }
                );
            }
        }

        /**
         * [getTreeData description]获取树数据
         * @param  {[obj]} params [description]请求参数
         * @param  {[string]} roleid   [description]角色Id非必传
         * @return {[type]}        [description]
         */
        function getTreeData1() {
            treeService.queryGroupTreeWithSecondRight().then(function(data) {
                $scope.data1.treeData = [data];
                ExpandedNodes1();
            });
        }

        /**
         * [ExpandedNodes1 description]默认展开树开始
         *
         * @return  {[type]}  [return description]
         */
        function ExpandedNodes1() {
            $scope.expandedTest1 = [];
            $scope.expandedTest1.push($scope.data1.treeData[0]);
            if ($scope.data1.treeData[0].CHILDREN === 0) {
                $scope.selectedNode1 = $scope.data1.treeData[0];
                getGroupData($scope.selectedNode1);
            } else {
                angular.forEach($scope.data1.treeData[0].CHILDREN, function(data, index, array) {
                    if (data.ISPATH === 'true') {
                        $scope.expandedTest1.push(data);
                        if (data.CHILDREN.length !== 0) {
                            selfPath(data);
                        } else {
                            $scope.selectedNode1 = data;
                            getGroupData($scope.selectedNode1);
                        }
                    }
                });
            }
        }

        /**
         * [getGroupData1 description]默认展开树结束
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        function getGroupData1(node) {
            $timeout(function() {
                $scope.groupObj = node;
            }, 100);
        }

        /**
         * [showSelected1 description]点击树回调函数开始
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.showSelected1 = function(node) {
            getGroupData1(node);
        };
        // 点击树回调函数结束

        /**
         * [ifSelected1 description]判断是否选中
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.ifSelected1 = function(node) {
            var flag = false;

            for (var i = 0; i < $scope.data.groupPaths.length; i++) {
                if (node.GROUPID == $scope.data.groupPaths[i].GROUPID || node.GROUPID == $scope.data.groupPaths[i].ID) {
                    $scope.data.groupPaths[i].selected = true;
                    node.selected = true;
                    flag = true;
                    break;
                }
            }

            return flag;
        };

        /**
         * [chooseFenzu description]判断是否选中
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.chooseFenzu = function(node) {
            var flag = false;
            for (var i = 0; i < $scope.data.selectedGroup.length; i++) {
                if (node.LABELORGANIZATIONID == $scope.data.selectedGroup[i].LABELORGANIZATIONID) {
                    $scope.data.selectedGroup[i].selected = true;
                    node.selected = true;
                    flag = true;
                    break;
                }
            }
            return flag;
            // if ($scope.data.selectedGroup.includes(node)) {
            //     $scope.data.selectedGroup.splice($scope.data.selectedGroup.indexOf(node), 1);
            // } else {
            //     $scope.data.selectedGroup.push(node);
            // }
        };

        /**
         * [chooseOrCancelFenzu description]判断是否选中
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.chooseOrCancelFenzu = function(node) {
            if (!node.LABELORGANIZATIONID) {
                return;
            }
            node.selected = !!(node.selected === undefined || node.selected === false);
            if (node.selected) {
                $scope.data.selectedGroup.push(node);
            } else {
                angular.forEach($scope.data.selectedGroup, function(data, index, array) {
                    if (data.LABELORGANIZATIONID == node.LABELORGANIZATIONID) {
                        $scope.data.selectedGroup[index].selected = false;
                        $scope.data.selectedGroup.splice(index, 1);
                    }
                });
            }
        };

        /**
         * [chooseGroup1 description]判断是否选中
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.chooseGroup1 = function(node) {
            if (node.PARENTID === '0') {
                return;
            }
            node.selected = !!(node.selected === undefined || node.selected === false);
            if (node.selected) {
                $scope.data.groupPaths.push(node);
            } else {
                cancelGroup1(node);
            }
        };

        /**
         * [cancelGroup1 description]
         *
         * @param   {[type]}  group  [group description]
         *
         * @return  {[type]}         [return description]
         */
        function cancelGroup1(group) {
            angular.forEach($scope.data.groupPaths, function(data, index, array) {
                if (data.GROUPID === group.GROUPID || data.ID === group.GROUPID) {
                    $scope.data.groupPaths[index].selected = false;
                    $scope.data.groupPaths.splice(index, 1);
                }
            });
        }

        $scope.cancelGroup1 = function(group) {
            cancelGroup1(group);
        };

        $scope.createGroup = function() {
            iwoNoticeService.createGroup().then((data) => {
                let params = {
                    labelName: data.groupName,
                    userIds: data.selectedArray.map((item) => item.ID).join(','),
                    trueNames: data.selectedArray.map((item) => item.USERNAME).join(','),
                };
                iwoNoticeService.addGroup(params).then((result) => {
                    getGroupList();
                });
            });
        };

        $scope.getSuggestions = function(viewValue) {
            return iwoNoticeService.getSearchValue(viewValue, $scope.status.selectedType);
        };
        // $scope.selectResource = function(value) {
        //     // console.log('我选中你了=》' + value);
        //     if ($scope.status.selectedType == 0) {
        //         $scope.directlyToRight(value);
        //         $scope.selectedArray = $scope.itemsSd;
        //     } else if ($scope.status.selectedType == 1) {
        //         $scope.chooseGroup1(value);
        //         // $scope.cancelGroup1(node);
        //         $scope.selectedArray = $scope.data.groupPaths;
        //     } else {
        //         $scope.chooseOrCancelFenzu(value);
        //         $scope.selectedArray = $scope.data.selectedGroup;
        //     }
        // };

        /**
         * [getSuggestions1] 匹配搜索框内关键词
         */
        // var promise;
        // $scope.getSuggestions1 = function(groupName) {
        //     if (promise) {
        //         $timeout.cancel(promise);
        //         promise = null;
        //     }
        //     promise = $timeout(function() {
        //         if (groupName !== '') {
        //             var params = {
        //                 serviceid: 'mlf_releasesource',
        //                 methodname: 'queryOrganizationsByKeyWords',
        //                 pageSize: 100,
        //                 queryOrganizationsByKeyWords: groupName,
        //             };

        //             if ($scope.static.isRequest) {
        //                 $scope.static.isRequest = false;
        //                 return [];
        //             } else {
        //                 return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
        //                     return data.DATA.map((i) => {
        //                         i.NAME = i.LABELNAME;
        //                     });
        //                     // console.log(data);
        //                 });
        //             }
        //         }
        //     }, 10);
        //     return promise;
        // };

        /**
         * [locationGroupTree1 description] 定位目标节点在组织树中的位置
         * @param  {[type]} gropuIds [description]
         * @return {[type]}          [description]
         */
        function locationGroupTree1(gropuIds) {
            $scope.expandedTest1 = [];
            var groupidsArray = gropuIds.split(',');
            groupidsArray.splice(0, 1);
            if (groupidsArray.length === 0) {
                $timeout(function() {
                    $scope.selectedNode1 = $scope.data1.treeData[0];
                    var isHasNode = false;
                    angular.forEach($scope.data.groupPaths, function(value, index) {
                        if (value.GROUPID == $scope.data1.treeData[0].GROUPID) {
                            isHasNode = true;
                        }
                    });
                    if (isHasNode === false) {
                        $scope.data1.treeData[0].selected = true;
                        $scope.data.groupPaths.push($scope.data1.treeData[0]);
                    }
                });
                return;
            }
            trsGroupTreeLocationService.groupTreeLocation(
                groupidsArray,
                $scope.data1.treeData[0],
                $scope.selectedNode1,
                $scope.expandedTest1,
                function(tree, array, selectedNode1) {
                    delete $scope.data1.treeData;
                    $scope.data1.treeData = [tree];
                    $scope.expandedTest1.push($scope.data1.treeData[0]);
                    $scope.selectedNode1 = selectedNode1;
                    var isHasNode = false;
                    angular.forEach($scope.data.groupPaths, function(value, index) {
                        if (value.GROUPID == selectedNode1.GROUPID) {
                            isHasNode = true;
                        }
                    });
                    if (isHasNode === false) {
                        selectedNode1.selected = true;
                        $scope.data.groupPaths.push(selectedNode1);
                    }
                }
            );
        }
    },
]);
